import { CalendarDays, Users, PhoneCall, FileText, Zap, ArrowRight } from "lucide-react";
import Reveal from "../Reveal";

const TOOLS = [
  { icon: CalendarDays, name: "Scheduling software", replaces: "Standalone booking calendars" },
  { icon: Users, name: "CRM software", replaces: "Separate customer databases" },
  { icon: PhoneCall, name: "Business phone system", replaces: "VoIP subscriptions & extra SIMs" },
  { icon: FileText, name: "Invoicing & payment tools", replaces: "Manual quoting & paper invoices" },
  { icon: Zap, name: "Automation & review tools", replaces: "Reminder and follow-up add-ons" },
];

const ReplacesStrip = () => (
  <section className="bg-white py-16 md:py-24 border-y border-slate-100" data-testid="replaces-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 leading-[1.2] mb-4">
          One platform instead of five separate tools
        </h2>
        <p className="text-lg text-slate-600 leading-relaxed">
          Every subscription you replace means one less login, one less bill, and zero double-entry between systems.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {TOOLS.map((t, i) => (
          <Reveal key={t.name} delay={Math.min(i + 1, 5)}>
            <div className="h-full rounded-2xl border border-slate-200 bg-white p-5 transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_16px_32px_-12px_rgba(15,23,42,0.14)] hover:border-blue-200" data-testid={`replaces-card-${i}`}>
              <div className="w-10 h-10 rounded-xl bg-[var(--mk-blue-light)] flex items-center justify-center mb-4">
                <t.icon className="w-5 h-5 text-[var(--mk-blue)]" />
              </div>
              <h3 className="text-[15px] font-semibold text-slate-900 mb-1.5">{t.name}</h3>
              <p className="text-[13px] text-slate-500 leading-relaxed flex items-start gap-1.5">
                <ArrowRight className="w-3.5 h-3.5 mt-0.5 shrink-0 text-emerald-600" />
                {t.replaces}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default ReplacesStrip;
